export enum FiatReplenishStatus {
  CREATED = 'CREATED',
  DONE = 'DONE',
  FAILED = 'FAILED'
}

export enum FiatReplenishFailedReason {
  BALANCE_NOT_FOUND = 'BALANCE_NOT_FOUND'
}
